import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CyberAuditATRReportComponent } from '../../CyberAudit/cyber-audit-atrreport/cyber-audit-atrreport.component';

@Component({
    selector: 'app-cell-atr-renderer',
    templateUrl: './cell-atr-renderer.component.html',
    standalone: false
})
export class CellAtrRendererComponent implements ICellRendererAngularComp {

  public cellValue !:string;
  changedValueForCopyPaste:any;
  cellName:any;
  params;
  cellData;
  listData:any;
  constructor(private systemAuditreportMis:CyberAuditATRReportComponent)
  {
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.cellValue = this.getValueToDisplay(params);
    this.params=params;
    this.listData = this.params.listData;
    console.log(this.params.dataType);
  }
  getValueToDisplay(params:ICellRendererParams)
{
  this.cellName = params.colDef.field;
  return params.valueFormatted?params.valueFormatted :params.value
}
  buttonClicked($event){
    // alert(`${this.cellValue} mai hu copy krne wala`);
    // console.log(this.cellData);
    if(this.params.dataType=='date')
    {
    this.changedValueForCopyPaste = new Date(this.cellData);
    }else{
    this.changedValueForCopyPaste = this.cellData;

    }
    this.systemAuditreportMis.onCellValueCopyFnChanged(this.cellName,this.changedValueForCopyPaste,$event);
    }
}
